import React from 'react';
import Selectable from '../common/selectable';

export default function ColumnHeaders(props) {
  let headers = props.columns.map((column, i) => {
    return (
      <td key={i} className={`abl-col-header ${column.className}`} colSpan={column.subColumns.items.length}>
        <Selectable
          id={column.name}
          data={column}
          selected={column.selected}
          overrideClick={true}
          onChange={props.onColumnClick}
          selectedClass="abl-selected">
          <div className="abl-cell" title={column.name}>
            {column.name}
          </div>
        </Selectable>
        <div className="abl-close-button" onClick={props.onColumnCloseClick.bind(null, column)}>X</div>
      </td>
    );
  });

  return (
    <tr>
      {headers}
    </tr>
  );
};


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule/column_headers.js
 **/